<template>
    <AuthLayout>
        <div class="flex flex-col gap-2 text-center">
            <h1 class="text-xl font-semibold text-[#1D4B61]">{{ $t('login.forgot_password') }}</h1>
            <p class="text-sm text-[#497384]">
                {{ $t('login.forgot_password_instructions') }}
            </p>
        </div>

        <form @submit.prevent="submit" class="flex flex-col w-full gap-4">
            <InputPrimary
                :placeholder="$t('login.email')"
                v-model="email"
                :icon="EmailIcon"
                type="email"
                class="text-[#497384]"
            />

            <ButtonComponent
                type="submit"
                :title="loading ? $t('login.sending') : $t('login.send_reset_link')"
                class="bg-[#3E7C94]"
                :disabled="loading"
            />

            <p v-if="error" class="text-sm text-red-600 text-center">{{ error }}</p>
            <p v-if="success" class="text-sm text-green-600 text-center">{{ success }}</p>

            <router-link to="/login" class="self-center text-sm text-[#3E7C94] hover:underline">
                {{ $t('login.back_to_login') }}
            </router-link>
        </form>
    </AuthLayout>
</template>

<script setup>
import { ref } from 'vue';
import axios from 'axios';
import InputPrimary from '@/components/inputs/input-primary.vue';
import EmailIcon from '@/assets/svg/EmailIcon.vue';
import ButtonComponent from '@/components/button/button-component.vue';
import AuthLayout from '@/components/layout/AuthLayout.vue';

const email = ref('');
const loading = ref(false);
const error = ref('');
const success = ref('');

const submit = async () => {
    loading.value = true;
    error.value = '';
    success.value = '';

    try {
        const response = await axios.post(
            `${import.meta.env.VITE_API_URL}/user/password/forgot`,
            { email: email.value },
            { headers: { 'Content-Type': 'application/json' } }
        );

        success.value = response.data?.value || 'Se ha enviado un enlace de restablecimiento a tu correo electronico.';
    } catch (err) {
        console.error(err);
        error.value = err.response?.data?.message || err.response?.data?.value || 'Ocurrio un error. Por favor, intentalo de nuevo.';
    } finally {
        loading.value = false;
    }
};
</script>
